import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { providerSearch, startProviderChat, fetchProviderToProviderConversations, clearSearch } from './actions';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import FormGroup from 'react-bootstrap/FormGroup';
import FormControl from 'react-bootstrap/FormControl';
import Badge from 'react-bootstrap/Badge';
import { bindActionCreators } from 'redux';
import { getKeyName } from '../helpers/getKeyName';
import S3Image from '../helpers/S3Image';

class ProviderConversations extends Component {
  state = {
    searchTerm: '',
  };

  componentDidMount() {
    this.props.fetchProviderToProviderConversations();
  }

  debounceSearch = _.debounce((term) => {
    this.props.providerSearch(term);
  }, 500);

  handleSearchInput = (e) => {
    const { value } = e.target;
    this.setState({ searchTerm: value });
    if (value.length >= 3) {
      this.debounceSearch(value);
    }
  };
  render() {
    return (
      <div>
        <Row>
          <Col lg={12}>
            <FormGroup className={'chat-sb-input'}>
              <FormControl type="text" name="text" id="exampleEmail" placeholder="Search Providers" onChange={this.handleSearchInput} value={this.state.searchTerm} />
              {this.props.matchFound.length > 0 ? (
                <div className={'search-result'}>
                  {this.props.matchFound.map((match) => (
                    <span
                      key={match.id}
                      onClick={() => {
                        this.props.clearSearch();
                        this.props.startProviderChat(match.id, match);
                        this.setState({ searchTerm: '' });
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <h6> {getKeyName(match, ['firstName', 'lastName'])}</h6>
                      <br />
                    </span>
                  ))}
                </div>
              ) : null}
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <ul className="friend">
            {this.props.providerToProviderConversations.map(({ userDetails, id, lastMessage }) => (
              <li
                key={id}
                className={'person'}
                onClick={() => {
                  // this.props.fetchCareMessages(id);
                  this.props.startProviderChat(userDetails.id, userDetails);
                }}
              >
                <S3Image s3Key={userDetails.imageUrl} className={'rounded-circle img-navbar img-cover'} style={{ width: 50, height: 50 }} />
                <span className={'name'}>{getKeyName(userDetails, ['firstName', 'lastName'])}</span>
                <Badge className={'unread'} color={'fff'}>
                  12
                </Badge>
                <span className={'preview'}>{lastMessage.message}</span>
              </li>
            ))}
          </ul>
        </Row>
      </div>
    );
  }
}

ProviderConversations.propTypes = {
  providerSearch: PropTypes.func,
  matchFound: PropTypes.array,
  startProviderChat: PropTypes.func,
  fetchProviderToProviderConversations: PropTypes.func,
  providerToProviderConversations: PropTypes.array,
  clearSearch: PropTypes.func,
};
ProviderConversations.defaultProps = {};

function mapStateToProps({ chat }) {
  return {
    matchFound: chat.matchFound,
    providerToProviderConversations: chat.providerToProviderConversations,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ providerSearch, startProviderChat, fetchProviderToProviderConversations, clearSearch }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ProviderConversations);
